import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { appointmentQKeys } from "@hooks/queries/appointment/queryKeys";
import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { timelineQKeys } from "@hooks/queries/timeline/queryKeys";


interface MutationProps {
  appointmentId: string;
  patientId: string;
}

export const useCreateConsultationWithAppointment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ appointmentId }: MutationProps) => {
      return api.post(`report/${appointmentId}`);
    },

    onSuccess: (_, variables) => {
      //   console.log(res?.data);
      queryClient.invalidateQueries({
        queryKey: appointmentQKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.patient(variables.patientId),
      });
      queryClient.invalidateQueries({
        queryKey: timelineQKeys.patient(variables.patientId),
      });
    },

    onError: (res, variables) => {
      console.error("[From Create Consultation With Appointment]", res);
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.patient(variables.patientId),
      });
    },
  });
};
